<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row type="flex">
          <a-col :md="6" >
            <a-form-item label="物料模板">
              <a-select show-search option-filter-prop="children" v-model="queryParams.templateName">
                <a-select-option v-for="(item) in templateNameList" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" >
            <a-form-item label="模板说明">
              <a-input v-model="queryParams.description" />
            </a-form-item>
          </a-col>
          <!-- 暂时隐藏 -->
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="物料类型">
              <global-select
                :value.sync="queryParams.itemType"
                selectType="selectMultiple"
                :selectData="itemTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="允许库存">
              <a-select v-model="queryParams.stockEnabledFlag">
                <a-select-option v-for="item in yesOrNo" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="可采购">
              <a-select v-model="queryParams.purchasingEnabledFlag">
                <a-select-option v-for="item in yesOrNo" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="集采类型">
              <global-select
                :value.sync="queryParams.centralizedPurchasingType"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findPurchasingTypeList"
                :selectItem="{ value: 'realValue', label: 'description' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划方法">
              <global-select
                :value.sync="queryParams.planningCode"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findPlanningCodeList"
                :selectItem="{ value: 'realValue', label: 'description' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="备料分类">
              <global-select
                :value.sync="queryParams.deliveryType"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findDeliveryTypeList"
                :selectItem="{ value: 'realValue', label: 'description' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="可制造">
              <a-select v-model="queryParams.buildInWipFlag">
                <a-select-option v-for="item in yesOrNo" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <!-- 暂时隐藏 -->
          <a-col :md="6" :sm="24" >
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!-- <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmItemTemplateNewExport" ref="download" />
      <a-button @click="handleAdd" type="primary" v-hasPermi="['mdm:itemTemplate:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mdm:itemTemplate:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MATERIAL_TEMPLATE_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="templateName" slot-scope="text">
            <a @click="handleDetail(text.record)">{{ text.text }}</a>
          </template>
          <template slot="templateStatus" slot-scope="text">
            <a-switch disabled :checked="text.text === 'Y'" />
          </template>
          <template slot="stockEnabledFlag" slot-scope="text">
            <a-switch disabled :checked="text.text === 'Y'" />
          </template>
          <template slot="lotControlCode" slot-scope="text">
            <a-switch disabled :checked="text.text === 'Y'" />
          </template>
          <template slot="reservableType" slot-scope="text">
            <a-switch disabled :checked="text.text === 'Y'" />
          </template>
          <template slot="purchasingEnabledFlag" slot-scope="text">
            <a-switch disabled :checked="text.text === 'Y'" />
          </template>
          <template slot="buildInWipFlag" slot-scope="text">
            <a-switch disabled :checked="text.text === 'Y'" />
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiItemTemplatePullDownList, apiItemTemplateList, apiMdmItemTemplateNewExport } from '@/api/mdm/matter/material-template'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'MaterialTemplate',
  components: { DownloadModal },
  data () {
    return {
      apiMdmItemTemplateNewExport,
      yesOrNo: [
        {
          key: "Y",
          value: "是"
        },
        {
          key: "N",
          value: "否"
        }
      ],
      itemTypeList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiItemTemplateList, true),
        pageCurrent: true
      },
      pageParams: {
        automatic: false,
        pageUrl: '/mdm/itemTemplate/list',
        tableLoading: false
      },
      isEdit: false,
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        templateName: undefined,
        description: undefined
      },
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '物料模板',
          width: 180,
          stickyFixed: 'left',
          dataIndex: 'templateName',
          scopedSlots: { customRender: 'templateName' },
          align: 'center'
        },
        {
          title: '模板说明',
          width: 220,
          stickyFixed: 'left',
          dataIndex: 'description',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '组织',
        //   dataIndex: 'organizationCode',
        //   align: 'center'
        // },
        {
          title: '模板状态',
          width: 120,
          dataIndex: 'templateStatus',
          scopedSlots: { customRender: 'templateStatus' },
          align: 'center'
        },
        {
          title: '物料类型',
          width: 120,
          dataIndex: 'itemType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物料状态',
          width: 120,
          dataIndex: 'itemStatusCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '允许库存',
          width: 120,
          dataIndex: 'stockEnabledFlag',
          scopedSlots: { customRender: 'stockEnabledFlag' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '批次控制',
          width: 120,
          dataIndex: 'lotControlCode',
          scopedSlots: { customRender: 'lotControlCode' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '可保留',
          width: 120,
          dataIndex: 'reservableType',
          scopedSlots: { customRender: 'reservableType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '可采购',
          width: 120,
          dataIndex: 'purchasingEnabledFlag',
          scopedSlots: { customRender: 'purchasingEnabledFlag' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '集采类型',
          width: 120,
          dataIndex: 'centralizedPurchasingType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '计划方法',
          width: 120,
          dataIndex: 'planningCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '制造或采购',
          width: 120,
          dataIndex: 'planningMakeBuyCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备料分类',
          width: 120,
          dataIndex: 'deliveryType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '可制造',
          width: 120,
          dataIndex: 'buildInWipFlag',
          scopedSlots: { customRender: 'buildInWipFlag' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'WIP供应类型',
          width: 120,
          dataIndex: 'wipSupplyType',
          ellipsis: true,
          align: 'center'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      templateNameList: [] // 物料模板
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getTemplateList()
    this.getLookupList('MDM_ITEM_TYPE', 'itemTypeList')
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/itemTemplate/export', {
      //   ...this.queryParams
      // }, `物料模板_${new Date().getTime()}.xlsx`)
    },
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 物料模板-下拉框
    getTemplateList () {
      apiItemTemplatePullDownList({ organizationCode: this.organizationCodeOrigin }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.label,
              value: element.label
            }
            list.push(obj)
          });
          this.templateNameList = list
        }
      })
    },
    handleDetail (record) {
      this.$router.push({ name: `material-template-detail`, query: { status: "edit", id: record.id } })
    },
    handleAdd () {
      this.$router.push({ name: `material-template-detail`, query: { status: "add", id: "" } })
    },
    /** 查询快码类型列表 */
    getList (data) {
      this.typeList = data
    },
    // 新增/修改框事件
    handleOk () {
     this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        templateName: undefined,
        description: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
